// replace with crypto.randomUUID() when the lowest version of Safari we support allows it
export function generateUUID() {
  // Create a typed array of 16 bytes (128 bits)
  const randomBytes = new Uint8Array(16);

  // Get cryptographically strong random values
  window.crypto.getRandomValues(randomBytes);

  // Set version to 4 (random UUID)
  randomBytes[6] = randomBytes[6] % 16 + 64;

  // Set variant to RFC4122
  randomBytes[8] = randomBytes[8] % 64 + 128;

  // Convert to hex values
  const hex = Array.from(randomBytes).map(byte => byte.toString(16).padStart(2, '0')).join('');

  // Format as UUID
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}